import { SearchBox } from "@fluentui/react";
import React,{useEffect,useState,useRef,useContext} from "react";
import DBadge from "../../../../components/SVGComponents/DBadge";
import PBadge from "../../../../components/SVGComponents/PBadge";
import RBadge from "../../../../components/SVGComponents/RBadge";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import TemplateList from "./TemplateList";
import { USERTYPES } from "../../../../constants/Constants";
import CLBadge from "../../../../components/SVGComponents/CLBadge";
import { t } from "i18next";
import themeContext from "../../../../context/theme/ThemeContext";
import LBadge from "../../../../components/SVGComponents/LBadge";
import { getEnv } from '../../../../helpers/EnvHelper';

const ContextMenuTemplate = (props) => {
  const isStudyList = true;
    const [rightPosition, setRightPosition] = useState(null);
    const [bottomOverflow, setBottomOverflow] = useState(false);
    const {getThemeColor,getAlterColor} = useContext(themeContext);
    const { showTemplateList,setShowTemplateList,rsnaFlag,setRSNAFlag } = useContext(studyReportContext);

    const ref = useRef(null);
    const { onClickOutside } = props;
   

    const {
        selectedCategoryTemplate,
        setSelectedCategoryTemplate,
        modality,
        userRole,
        isClientReportExist,isRestrictionsEnabled,
        isDSRExists,
        setActiveTab,
        allReportTemplates,
        handleDropdownWithContext,
        studyDescription
      } = useContext(studyReportContext);
    // useEffect(()=>{
    //     console.log(showTemplateList);
    // },[showTemplateList])

    useEffect(() => {
        const handleClickOutside = (event) => {
          if (ref.current && !ref.current.contains(event.target)) {
            onClickOutside && onClickOutside();
            setShowTemplateList(()=>{
                const newItem = {...showTemplateList};
                newItem.showTemplate = true;
                newItem.selectedList = null;
                return newItem;
            });
          }
        };
        document.addEventListener("click", handleClickOutside, true);
        return () => {
          document.removeEventListener("click", handleClickOutside, true);
        };
      }, [onClickOutside]);

    
    const handleSelectType = (type) => {
        setShowTemplateList(()=>{
            const newItem = {...showTemplateList};
            newItem.showTemplate = true;
            newItem.selectedList = type;
            return newItem;
        });
        setSelectedCategoryTemplate(type);
    }

    const handleBackClick = () => {
        setShowTemplateList(()=>{
            const newItem = {...showTemplateList};
            newItem.showTemplate = false;
            newItem.selectedList = null;
            return newItem;
        });
    }

    useEffect(()=>{
        if(!props.show){
            setShowTemplateList(()=>{
                const newItem = {...showTemplateList};
                newItem.showTemplate = true;
                newItem.selectedList = null;
                return newItem;
            });
        }
    },[props.show])

    useEffect(() => {
      if(props.show){

        const modalElement = ref.current;
        const rect = modalElement.getBoundingClientRect();
        const isOutsideLeft = rect.left < 0;
        const isOutsideRight = rect.right > window.innerWidth;
        const isOutsideTop = rect.top < 0;
        const isOutsideBottom = rect.bottom > window.innerHeight;

        if (isOutsideLeft || isOutsideRight) {
          setRightPosition('0px');
        } else {
          setRightPosition(null);
        }

        if (isOutsideBottom) {
          setBottomOverflow(true);
        } else {
          setBottomOverflow(false);
        }
      }
    }, [props.show]);

    if (!props.show) return null;

    return (
      <div ref={ref} className="context-menu-report" 
      style={{
        right:rightPosition !=null?rightPosition:'unset',
        ...(bottomOverflow ? { bottom: '106%', top: 'unset' } : {}),
        background: isStudyList ? getThemeColor("report-template-container") : "#201F1E"
        }}>
        {!showTemplateList.showTemplate ? (
          <div className="context-menu-div">
            <div className="select-report-text">
              <span style={{color: getAlterColor("#a19f9d","#000")}} className=" badge-text-report no-margin">
                {t("report.select-type")}
              </span>
            </div>
           {isRestrictionsEnabled && isClientReportExist ? 
              <div
                className="aligning-container"
                onClick={() => {
                  handleSelectType("clientReportTemplate");
                  setRSNAFlag(false);
                }}
              >
                <div style={{ display: "flex" }}>
                  <CLBadge />
                  <span style={{color: getAlterColor("#a19f9d","#000")}} className="badge-text-report">{t("report.client-report")}</span>
                </div>
              </div>
            
            :
                <>
                {isClientReportExist && <div
                className="aligning-container"
                onClick={() => {
                  handleSelectType("clientReportTemplate");
                  setRSNAFlag(false);
                }}
              >
                <div style={{ display: "flex" }}>
                  <CLBadge />
                  <span style={{color: getAlterColor("#a19f9d","#000")}} className="badge-text-report">{t("report.client-report")}</span>
                </div>
              </div>}
              {isDSRExists && <div className="aligning-container"
                onClick={() => {
                  handleSelectType("dsrTemplate");
                  setRSNAFlag(false);
                }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <LBadge />
                  <span style={{color: getAlterColor("#a19f9d","#000")}} className="badge-text-report">{t("report.llm-report")}</span>
                </div>
                </div>}
            <div
              className="aligning-container"
              onClick={() => {
                handleSelectType("deeptekReportTemplage");
                setRSNAFlag(false);
              }}
            >
              <div style={{ display: "flex" }}>
                <DBadge />
                <span style={{color: getAlterColor("#a19f9d","#000")}} className="badge-text-report">{getEnv("REACT_APP_VDC_PLATFORM") == "true" ? t("report.vdc-report") : t("report.deeptek-report")}</span>
              </div>
            </div>
            {modality.length > 0 &&
              modality != "MR" &&
              modality != "CT" &&
              userRole == USERTYPES.RADIOLOGIST && getEnv("REACT_APP_VDC_PLATFORM") == "false" && (
                <div
                  className="aligning-container"
                  onClick={() => {
                    handleSelectType("rsnaReportTemplage");
                    setRSNAFlag(true);
                  }}
                >
                  <div style={{ display: "flex" }}>
                    <RBadge />
                    <span style={{color: getAlterColor("#a19f9d","#000")}} className="badge-text-report">{t("report.rsna-report")}</span>
                  </div>
                </div>
              )}
            {userRole == USERTYPES.RADIOLOGIST && getEnv("REACT_APP_VDC_PLATFORM") == "false" && (
              <div
                className="aligning-container"
                onClick={() => {
                  handleSelectType("radiologistReportTemplate");
                  setRSNAFlag(false);
                }}
              >
                <div style={{ display: "flex" }}>
                  <PBadge />
                  <span style={{color: getAlterColor("#a19f9d","#000")}} className="badge-text-report">{t("report.radiologist-report")}</span>
                </div>
              </div>
            )}</>}
          </div>
        ) : (
          <TemplateList
            rsnaFlag={rsnaFlag}
            onClickOutside={onClickOutside}
            handleBackClick={handleBackClick}
          />
        )}
      </div>
    );
}

export default ContextMenuTemplate;